import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createResourceValidator } from "../resources/SWBaseResource";
/** @public */ /** @internal */ export const rootResourceVersions = {};
/** @internal */ export const rootResourceMigrations = defineMigrations({});
/** @public */ export function isResource(record) {
    if (!record) return false;
    return record.typeName === "resource";
}
/** @public */ export function isResourceId(id) {
    if (!id) return false;
    return id.startsWith("resource:");
}
export const parseResourceId = (id)=>{
    if (!id) return undefined;
    if (!id.startsWith("resource:")) return undefined;
    // Split into many pieces
    const parts = id.replace("resource:", "").split(":");
    // if (parts.length !== 4) return undefined
    const type = parts.shift();
    const reversed = parts.reverse();
    const scope = reversed.shift();
    const _organizationId = reversed.shift();
    const name = reversed.reverse().join(":");
    const organizationId = parseInt(_organizationId || "");
    if (isNaN(organizationId)) return undefined;
    if (scope !== "global" && scope !== "organization") return undefined;
    return {
        type: type,
        name,
        organizationId,
        scope: scope
    };
};
// /** @public */
// export function createResourceId(id?: string): SWResourceId {
//   return `resource:${id ?? nanoid()}` as SWResourceId
// }
export const createResourceIdPrefix = (type)=>`resource:${type}:`;
// 'resource:<type>:<name>:<org-id>:global|organization:0'
export function createResourceId({ type, name, organizationId, scope }) {
    return `resource:${type}:${name}:${organizationId}:${scope}`;
}
export function createTextResourceVariantId({ type, name, organizationId, scope, variant }) {
    return `resource_variant:${type}:${name}:${organizationId}:${scope}:${variant}`;
}
/** @internal */ export function createResourceRecordType(resources) {
    return createRecordType("resource", {
        migrations: undefined,
        scope: "session",
        validator: T.model("resource", T.union("type", mapObjectMapValues(resources, (type, { props, meta })=>createResourceValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {}
        }));
}
export function castResourceId(id) {
    return {
        toResourceVariantIdPrefix (varint) {
            return id.replace(/^resource:/, "resource_variant:") + (varint ? ":" + varint : "");
        },
        toResourceVariantStoredIdPrefix (variant) {
            return id.replace(/^resource:/, "resource_variant_stored:") + (variant ? ":" + variant : "");
        }
    };
}
export function castResourceVariantId(id) {
    return {
        toResourceVariantStoredId () {
            return id.replace(/^resource_variant:/, "resource_variant_stored:");
        },
        toResourceId () {
            const parts = id.replace(/^resource_variant:/, "resource:").split(":");
            const variant = parts.pop();
            return parts.join(":");
        }
    };
}
export function castResourceVaraint(resourceVariant) {
    return {
        toResourceVariantStored () {
            const id = castResourceVariantId(resourceVariant.id).toResourceVariantStoredId();
            return {
                ...resourceVariant,
                typeName: "resource_variant_stored",
                id
            };
        },
        toResource () {
            const id = castResourceVariantId(resourceVariant.id).toResourceId();
            const { variant, variantVersion, ...rest } = resourceVariant;
            return {
                ...rest,
                typeName: "resource",
                id
            };
        }
    };
}
export function castResource(resource) {
    return {
        toResourceVariant ({ variant, variantVersion }) {
            const id = castResourceId(resource.id).toResourceVariantIdPrefix(variant);
            return {
                ...resource,
                variant,
                variantVersion,
                typeName: "resource_variant",
                id
            };
        }
    };
} // // 'resource:<type>:<name>:<org-id>:global|organization'
 // export interface SWResource extends BaseRecord<"resource", SWResourceId> {
 //   type: "snippet"
 //   name: string
 //   organizationId: number
 //   scope: "global" | "organization"
 // }
 // export const SWResourceValidator: T.Validator<SWResource> = T.model(
 //   "resource",
 //   T.object({
 //     id: idValidator<SWResourceId>("resource"),
 //     typeName: T.literal("resource"),
 //     type: T.literal("snippet"),
 //     name: T.string,
 //     description: T.string.optional(),
 //     organizationId: T.number,
 //     scope: T.literalEnum("global", "organization"),
 //   }).refine((r) => {
 //     // TODO: The idenifier must match the rest of the type
 //     // The idenifier must match the rest of the type
 //     return r
 //   })
 // )
 // export const SWResourceRecordType = createRecordType<SWResource>("resource", {
 //   migrations: defineMigrations({}),
 //   validator: SWResourceValidator,
 //   scope: "document",
 // }).withDefaultProperties(() => ({}))
 // // The resource version is a snapshot of the resource at a specific point in
 // // time.
 // // 'resource:<type>:<name>:<org-id>:global|organization:0'
 // type SWResourceVersionId = RecordId<SWResourceVersion>
 // export interface SWResourceVersion extends BaseRecord<"resource_version", SWResourceVersionId> {
 //   type: "snippet"
 //   name: string
 //   organizationId: number
 //   scope: "global" | "organization"
 //   version: number
 //   previewUrl?: string
 //   value: {
 //     type: "snippet"
 //     storageKey: string
 //   }
 //   // A reference to where to load the resource from
 // }
 // export function isResource(record?: UnknownRecord): record is SWResource {
 //   if (!record) return false
 //   return record.typeName === "resource"
 // }
 // export function isResourceId(id?: string): id is SWResourceId {
 //   if (!id) return false
 //   return id.startsWith("resource:")
 // }
 // /** @public */
 // export function createResourceId(id?: string): SWResourceId {
 //   return `resource:${id ?? nanoid()}` as SWResourceId
 // }
